/**
 * ACT2-1124: an account of a readable workspace as a tile, for Settings › Accounts' card view. Its one action is Copy.
 */
import { ListCard } from '@/_shared/components/list/ListCard';
import { Badge } from '@/_shared/components/ui/badge';
import { destinationTypeIcon } from '@/audiences/icons/destinationTypes';

import type { OrganizationAccountListRow } from '../../lib/accountList';
import { CopyAccountButton } from '../accountCopies/CopyAccountButton';

export function OrganizationAccountCard({ account }: { account: OrganizationAccountListRow }): React.JSX.Element {
  const Icon = destinationTypeIcon(account.destinationType).Icon;
  return (
    <ListCard
      title={account.name}
      // Decorative: the card's own text already names the account and its type.
      titleIcon={
        <span aria-hidden className="flex shrink-0 items-center">
          <Icon className="size-4" />
        </span>
      }
      badges={
        <Badge variant="outline" className="shrink-0 text-xs">
          {account.authLabel}
        </Badge>
      }
      actions={<CopyAccountButton row={account} />}
      description={`From ${account.option.workspaceName}`}
      meta={
        <span className="truncate" title={account.typeLabel}>
          {account.typeLabel}
        </span>
      }
    />
  );
}
